// Central source of truth for SEO / social metadata.
// Do not disperse variants of the domain or brand name across the codebase.

export const SITE_URL = "https://visionature.net";
export const SITE_NAME = "Visionature";
export const DEFAULT_LOCALE = "fr_FR";
export const DEFAULT_OG_IMAGE = "/og/visionature-default.webp";
export const DEFAULT_OG_IMAGE_WIDTH = 1200;
export const DEFAULT_OG_IMAGE_HEIGHT = 630;

/**
 * Build an absolute URL on the canonical domain from a route path.
 * Root path stays as "/"; other paths are normalized without a trailing slash.
 */
export function absoluteUrl(path: string = "/"): string {
  if (!path || path === "/") return `${SITE_URL}/`;
  const trimmed = path.trim();
  // Strip query/hash — canonicals never carry hash and rarely need query.
  const [pathnameRaw] = trimmed.split(/[?#]/);
  const normalized = "/" + pathnameRaw.replace(/^\/+|\/+$/g, "");
  return `${SITE_URL}${normalized}`;
}

/**
 * Ensure an image path becomes an absolute URL on the canonical domain
 * (unless already absolute http(s)).
 */
export function absoluteImage(image?: string): string {
  const src = image && image.length > 0 ? image : DEFAULT_OG_IMAGE;
  if (/^https?:\/\//i.test(src)) return src;
  const normalized = src.startsWith("/") ? src : `/${src}`;
  return `${SITE_URL}${normalized}`;
}
